import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

import type { UserDirectoryPreviewResponse } from "./types";

export const isUserDirectoryPreviewResponse = objectOf<UserDirectoryPreviewResponse>({
  user_directory: arrayOf(
    objectOf({
      id: string,
      appboy_id: string,
      name: anyOf(string, nullOrUndefined),
      num_sessions: anyOf(number, nullOrUndefined),
      first_session: anyOf(number, nullOrUndefined),
      last_session: anyOf(number, nullOrUndefined),
      gender: anyOf(string, nullOrUndefined),
      language: anyOf(string, nullOrUndefined),
      country: anyOf(string, nullOrUndefined),
      age: anyOf(string, nullOrUndefined),
      email: anyOf(boolean, nullOrUndefined),
      push: anyOf(boolean, nullOrUndefined),
    })
  ),
});
